import React from 'react'
import { Page } from '../../components/Page'
import { SettingsSection } from './components/SettingsSection'
import { BillingSection } from './components/BillingSection'

export const Account: React.FC = () => {
  return (
    <Page>
      <SettingsSection />
      <BillingSection />
    </Page>
  )
}

